import { faGithub } from "@fortawesome/free-brands-svg-icons/faGithub";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons/faEnvelope";
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: "https://github.com/Dimeji-go/",
    label: "Github",
    icon: faGithub,
  },
  {
    link: "https://www.linkedin.com/in/oladimeji-eludini-3b6916272?utm_source=share&utm_campaign=share_via&utm_content=profile",
    label: "LinkedIn",
    icon: faLinkedinIn,
  },
  {
    link: "https://x.com/heishim_go",
    label: "Twitter",
    icon: faTwitter,
  },
  {
    link: "mailto:dimejiishim@gmail.com",
    label: "Email",
    icon: faEnvelope,
  },
];

export default data;
